import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../../constants/dataAids';

const styles = {
  marginBottom: 'xsmall'
};

function Quantity(props) {
  const {
    Grid,
    Grid: { Cell }
  } = UX2.Component;
  const { Input, Label } = UX2.Element;

  return (
    <Grid size={ 3 } style={{ alignItems: 'flex-end' }}>
      <Cell xs={ props.size || 1 } style={{ paddingRight: '0' }}>
        <Label children={ props.translate('products.quantity') } style={ styles } />
        <Input
          tag='input'
          data-aid={ dataAids.PRODUCT_QUANTITY }
          pattern='[0-9]*'
          min='1'
          max='999'
          type='number'
          value={ props.quantity }
          onChange={ props.onChange }
          style={{ width: '100%' }}
        />
      </Cell>
    </Grid>
  );
}

Quantity.propTypes = {
  onChange: PropTypes.func,
  quantity: PropTypes.number,
  size: PropTypes.number,
  translate: PropTypes.func
};

export default Quantity;
